import React from "react"
import ProductModel from "theme/base/shop/ProductModel"

export default class ProductModelDonkey extends ProductModel {
	constructor( ...data ) {
		super( ...data )

		let q = this.quantityById["vacos_ve"]
		if(q){
			this.quantities = this.quantities.filter( q => {
				return q.map_desc_id === "vacos_ve"
			})
			this.unit_id = q.map_desc_id
			this.unit_multi = q.multi
			this.unit_desc = q.des
		}
	}
}



// WEBPACK FOOTER //
// ./src/theme/donkey/shop/ProductModel.js